import React, { useState } from "react";
import styled from "styled-components";
import InputField from "./InputField.tsx";

import { TfiSave } from "react-icons/tfi";

import Button from "./Button.tsx";

import { addNewSupplier } from "../../../services/filamentService.js";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  padding: 1rem 2rem;

  align-items: center;
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    min-width: 200px;
  }
`;

const SettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 1rem;
  width: 100%;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
`;

interface Props {
  closeAddMode: (string) => void;
}

const AddSupplierComponent: React.FC<Props> = ({ closeAddMode }) => {
  const [isError, setIsError] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [weight, setWeight] = useState("");

  const handleSave = async () => {
    // Save the filament to the database

    if (name && weight) {
      setIsError(false);

      const supplier = {
        supplierName: name,
        phoneNumber: phone ? phone : "-",
        email: email ? email : "-",
        spoolWeight: weight,
      };

      try {
        await addNewSupplier(supplier);
        closeAddMode("success");
      } catch (error) {
        closeAddMode("error");
        console.error("Error creating type:", error);
      }
    } else {
      setIsError(true);
    }
  };

  return (
    <Wrapper data-testid="add-supplier-tile">
      <Container>
        <SettingWrapper data-testid="supplier-settings">
          <InputField
            name="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nume"
            label="Nume"
            isRequired
          />
          <InputField
            name="phone"
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Telefon"
            label="Telefon"
          />
          <InputField
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            label="Email"
          />
          <InputField
            name="weight"
            type="number"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            isRequired
            placeholder="Greutate rolă"
            label="Greutate rolă"
          />
          {isError && (
            <p style={{ color: "#c72418", margin: 0 }}>
              *Câmpuri necompletate !
            </p>
          )}
          <Buttons>
            <Button
              id="save-supplier"
              onClick={handleSave}
              text="SAVE"
              icon={<TfiSave />}
              backgroundColor={"var(--secondary-green)"}
              color="white"
            />
          </Buttons>
        </SettingWrapper>
      </Container>
    </Wrapper>
  );
};

export default AddSupplierComponent;
